import React from 'react';
import { Container, Button, Row, Col } from 'react-bootstrap';
import { FaXTwitter, FaLinkedin } from 'react-icons/fa6';

function MainPage() {
  return (
    <div className="main-page">
      <div className="background-slider">
        <div className="background-image"></div>
        <div className="background-image"></div>
        <div className="background-image"></div>
      </div>
      <Container className="py-5 position-relative text-center">
        <Row className="justify-content-center align-items-center min-vh-100">
          <Col md={8}>
            <h1 className="main-title text-white aref-ruqaa text-shadow-enhanced">حمد المنيف</h1>
            <p
              className="mt-2 aref-ruqaa text-shadow-medium"
              style={{
                color: '#000',
                fontSize: '1.5rem',
                fontWeight: '300',
                fontStyle: 'italic',
              }}
            >
              'صانع التغيير من خلال التواصل وتطوير الإمكانات'
            </p>
            <p className="lead mt-3 text-white text-shadow-medium">
              إعلامي سعودي 🇸🇦 | خبير بناء القدرات البشرية | مستشار التطوير التنظيمي والموارد البشرية | مستشار التواصل الاستراتيجي
            </p>
            <p className="mt-3 text-white text-shadow-light">
              مرحبًا بكم في موقعي الشخصي، حيث أشارككم خبراتي ورؤيتي في تطوير القدرات البشرية، بناء الاستراتيجيات التنظيمية، والتواصل الفعّال. هنا ستجدون كل ما يتعلق بمسيرتي المهنية ومشاريعي المتنوعة.
            </p>
            <div className="mt-4">
              <Button variant="outline-light" size="lg" href="/about" className="btn-shadow">
                اعرف المزيد عني
              </Button>
            </div>
            <div className="mt-4">
              <a
                href="https://x.com/HamadAlMuneef"
                target="_blank"
                rel="noopener noreferrer"
                className="me-3 social-icon"
                style={{ fontSize: '1.5rem', color: '#000' }}
              >
                <FaXTwitter />
              </a>
              <a
                href="https://linkedin.com/in/hamadalmuneef"
                target="_blank"
                rel="noopener noreferrer"
                className="social-icon"
                style={{ fontSize: '1.5rem', color: '#000' }}
              >
                <FaLinkedin />
              </a>
            </div>
          </Col>
        </Row>
      </Container>
    </div>
  );
}

export default MainPage;